// extracted by mini-css-extract-plugin
export default {"button":"CheckoutButton--button--9ab432"};